<div #customerTableContainer class="customers-grid group-pricing-grid">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div *ngIf="customersDataSource" class="col-6">
                <app-table-global-search [matDataSource]="customersDataSource"
                                         placeholder="Search by Company"></app-table-global-search>
            </div>
            <div class="col-6 d-flex justify-content-end align-items-center">
                <div>
                    <button [matMenuTriggerFor]="gridActions" mat-icon-button>
                        <mat-icon aria-hidden="true"
                                  class="mat-icon material-icons"
                                  role="img">settings</mat-icon>
                    </button>
                    <mat-menu #gridActions="matMenu"
                              class="switch-nested-menu-left-arrows"
                              xPosition="before">
                        <button (click)="exportCustomersToExcel()"
                                mat-menu-item>
                            Export
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>

    <div #scrollContainer class="table-container" (scroll)="onTableScroll($event)">
            <table mat-table [dataSource]="customersDataSource" matSort [trackBy]="trackByCustomerId">
                <ng-container matColumnDef="company_group">
                    <th mat-header-cell *matHeaderCellDef class="first-header"></th>
                </ng-container>
                <ng-container *ngFor="let grp of groupHeaderColumns.slice(1)" [matColumnDef]="grp.id">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="first-header">
                        {{ grp.name }}
                    </th>
                </ng-container>
                <ng-container matColumnDef="company">
                    <th mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        class="second-header">
                        {{ columnLabels.get('company') }}
                    </th>
                    <td mat-cell
                        *matCellDef="let row"
                        class="grid-cell">
                        {{ row['company'] }}
                    </td>
                </ng-container>
                <ng-container *ngFor="let colId of dynamicColumnIds" [matColumnDef]="colId">
                    <th mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        class="second-header"
                        [ngClass]="columnGroupClasses.get(colId)">
                        {{ columnLabels.get(colId) }}
                    </th>
                    <td mat-cell
                        *matCellDef="let row"
                        class="grid-cell clickable-cell"
                        [class.hovered-group]="isCellInHoveredGroup(row, colId)"
                        [ngClass]="columnGroupClasses.get(colId)"
                        (click)="onCellClick(row, colId)"
                        (mouseenter)="onCellMouseEnter(row, colId)"
                        (mouseleave)="onCellMouseLeave()">
                        {{ row[colId] }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="groupHeaderIds"></tr>
                <tr mat-header-row *matHeaderRowDef="columnIds"></tr>
                <tr mat-row *matRowDef="let row; columns: columnIds"></tr>
            </table>
    </div>

    <mat-paginator (page)="onPageChanged($event)"
                   [length]="customersData?.length"
                   [pageSizeOptions]="[10, 25, 50, 100]"
                   [pageSize]="pageSize"
                   style="display: none;"></mat-paginator>
</div>
